/**
 * @generated SignedSource<<6362a5177f024a3f2c4bf87572806003>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AppOrganizationSelectDestinationInputTransferMutation$variables = {
  appId: string;
  organizationId: string;
};
export type AppOrganizationSelectDestinationInputTransferMutation$data = {
  readonly requestAppTransferToOrganization: {
    readonly transferRequestDestination: {
      readonly imageUrl?: string | null | undefined;
      readonly name?: string;
    } | null | undefined;
  };
};
export type AppOrganizationSelectDestinationInputTransferMutation = {
  response: AppOrganizationSelectDestinationInputTransferMutation$data;
  variables: AppOrganizationSelectDestinationInputTransferMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "organizationId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "appId",
    "variableName": "appId"
  },
  {
    "kind": "Variable",
    "name": "organizationId",
    "variableName": "organizationId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppOrganizationSelectDestinationInputTransferMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "App",
        "kind": "LinkedField",
        "name": "requestAppTransferToOrganization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "transferRequestDestination",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*:: as any*/),
                  (v3/*:: as any*/)
                ],
                "type": "Organization",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "AppOrganizationSelectDestinationInputTransferMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "App",
        "kind": "LinkedField",
        "name": "requestAppTransferToOrganization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "transferRequestDestination",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*:: as any*/),
                  (v3/*:: as any*/),
                  (v4/*:: as any*/)
                ],
                "type": "Organization",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "382363621a7c8960328bf04339509496",
    "id": null,
    "metadata": {},
    "name": "AppOrganizationSelectDestinationInputTransferMutation",
    "operationKind": "mutation",
    "text": "mutation AppOrganizationSelectDestinationInputTransferMutation(\n  $appId: ID!\n  $organizationId: ID!\n) {\n  requestAppTransferToOrganization(appId: $appId, organizationId: $organizationId) {\n    transferRequestDestination {\n      __typename\n      ... on Organization {\n        imageUrl\n        name\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "43fe24f06dc0cc01ceafcf475a343b36";

export default node;
